import { render } from "./Pricing.vue?vue&type=template&id=83070b52"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ZyMall/components/pricing/Pricing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83070b52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83070b52', __exports__)) {
    api.reload('83070b52', __exports__)
  }
  
  module.hot.accept("./Pricing.vue?vue&type=template&id=83070b52", () => {
    api.rerender('83070b52', render)
  })

}


export default __exports__